import React, { useRef, useState,useEffect } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import "./Waitlist.css";
import { emailjs } from '@emailjs/browser';
function Waitlist() {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [dark, setDark] = useState(true);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        who: ""
    });

    useEffect(() => {
        const intervalId = setInterval(() => {
        let theme = localStorage.theme;
        setDark(theme === "dark" ? true : false);
        }, 500);

        return () => clearInterval(intervalId);
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        
    };

    const sendEmail = async (e) => {
        e.preventDefault();
        setIsSubmitting(true); // Disable button while submitting

        const payload = {
            name: formData.name,
            email: formData.email,
            who: formData.who,
        };

        try {
            const response = await toast.promise(
                fetch(`${process.env.REACT_APP_BACKEND_URL}/store_izzyai_user`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                }).then(async (res) => {
                    const data = await res.json();
                    if (!res.ok) {
                        throw new Error(data.error || "Failed to submit the request");
                    }
                    return data;
                }),
                {
                    loading: "Submitting your request...",
                    success: "Request submitted successfully!",
                    error: "Failed to submit the request or alredy submitted for email.",
                }
            );

            console.log("Response:", response);

            formData({});

        } catch (error) {
            console.error("Error:", error);
        } finally {
            setIsSubmitting(false); // Re-enable the button
        }
    };

    return (
        <>
            {/* <div className="pb-24">
                <div className="mt-10">
                    <div>
                        <p className="font-bold text-xl dark:text-white text-center">
                            Boost Efficiency & Revenue for Your Practice With AI-Powered Therapists
                        </p>
                        <p className="dark:text-white mt-5 text-center">
                            Schedule a demo to discover how IzzyAI can streamline processes and reduce costs.
                        </p>
                    </div>
                    <div className="mt-10 mx-3 2xl:mx-96 xl:mx-96 lg:mx-72 md:mx-56 sm:mx-10 bg-[#CBD5E1] rounded-lg p-6 pb-10">
                        <form className="space-y-6" onSubmit={sendEmail} ref={formRef}>
                            <div className="md:flex md:space-x-6">
                                <div className="md:w-2/3">
                                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                        Name*
                                    </label>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        autoComplete="name"
                                        placeholder="Enter Your Name"
                                        className="mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:outline-[#0CC8E8]"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="md:flex md:space-x-6">
                                <div className="md:w-2/3">
                                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                        Email*
                                    </label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        placeholder="Enter Your Email"
                                        className="mt-1 p-2 block w-full border-gray-300 rounded-md shadow-sm focus:outline-[#0CC8E8]"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="md:flex md:space-x-6 mt-4">
                                <div className="md:w-1/2">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Who Will Be Using IzzyAI?
                                    </label>
                                    <div className="mt-1 space-y-2">
                                        {["Myself", "My Child", "Someone I Care For", "Clinic"].map((option) => (
                                            <label key={option} className="flex items-center space-x-2">
                                                <input
                                                    type="radio"
                                                    name="who"
                                                    value={option}
                                                    className="h-4 w-4 text-[#0CC8E8] border-gray-300 focus:ring-[#0CC8E8]"
                                                    required
                                                />
                                                <span className="text-gray-700 text-sm">{option}</span>
                                            </label>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    className={`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white 
                                    bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] hover:from-teal-600 hover:to-green-500 focus:outline-none focus:ring-2 
                                    focus:ring-offset-2 focus:ring-indigo-500 ${
                                        isSubmitting ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                >
                                    {isSubmitting ? "Submitting..." : "Sign Up For Waitlist"}
                                </button>
                            </div>
                        </form>
                        <Toaster />
                    </div>
                </div>
            </div> */}
            <div className={`waitlist bg-cover bg-center h-screen relative text-white 2xl:pt-40 xl:pt-40 lg:pt-28 md:pt-28 pt-28`}
                // style={{ backgroundImage: `url('/images/${dark ? 'bg-1.jpg':'white-bg.jpg'}')`}}
            >
                <div className="container mx-auto px-4">
                    <div className=" items-center h-full">
                        <div className="text-center mx-auto">
                            <div className="slider-content mx-auto">
                                <p className="  font-bold mb-4 dark:text-white text-black">
                                    <span className='2xl:text-4xl xl:text-4xl lg:text-4xl md:text-4xl text-2xl'>Welcome to IzzyAI</span> <span className="block">Get Ready! Your AI Powered Speech Language Therapist Is On The Way!</span>
                                </p>
                                <div className="contact-box p-6 rounded-lg shadow-lg text-black">
                                    <form id="contact-form" className="form-group" method="POST" action="mail.php" autoComplete='off'>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                                            <input 
                                                type="text" 
                                                name="name" 
                                                id="name" 
                                                placeholder="Full Name" 
                                                required
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                className="text-black dark:text-white border border-gray-300 dark:bg-[#232323] px-2 py-4 w-full rounded-md focus:outline"
                                            />
                                            <input 
                                                name="email" 
                                                type="email" 
                                                placeholder="Email" 
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                required 
                                                className="border dark:text-white border-gray-300 dark:bg-[#232323] px-2 py-4 w-full rounded-md"
                                            />
                                        </div>
                                        <div className="md:flex md:space-x-6 mt-4 justify-center">
                                            <div className="md:w-1/2">
                                                <label className="block text-sm font-medium dark:text-white text-black">
                                                    Who Will Be Using IzzyAI?
                                                </label>
                                                <div className='flex flex-wrap justify-center'>
                                                    <div className="mt-1 flex  flex-wrap mb-2 w-full ">
                                                            <label key={"Myself"} className="flex items-center space-x-2 ">
                                                                <input
                                                                    type="radio"
                                                                    name="who"
                                                                    value="Myself"
                                                                    onChange={handleInputChange}
                                                                    className="h-4 w-4  border-gray-300 focus:ring-[#0CC8E8] foucs:outline-none"
                                                                    required
                                                                />
                                                                <span className="dark:text-white text-black text-sm">Myself</span>
                                                            </label>
                                                    </div>
                                                    <div className="mt-1 flex flex-wrap mb-2 w-full">
                                                            <label key={"My Child"} className="flex items-center space-x-2 ">
                                                                <input
                                                                    type="radio"
                                                                    name="who"
                                                                    value="My Child"
                                                                    onChange={handleInputChange}
                                                                    className="h-4 w-4  border-gray-300 focus:ring-[#0CC8E8]"
                                                                    required
                                                                />
                                                                <span className="dark:text-white text-black text-sm">My Child</span>
                                                            </label>
                                                    </div>
                                                </div>
                                                <div className='flex flex-wrap justify-center'>
                                                    <div className="mt-1 flex  flex-wrap mb-2 w-full ">
                                                            <label key={"Someone I Care For"} className="flex items-center space-x-2 ">
                                                                <input
                                                                    type="radio"
                                                                    name="who"
                                                                    value="Someone I Care For"
                                                                    onChange={handleInputChange}
                                                                    className="h-4 w-4  border-gray-300 focus:ring-[#0CC8E8] foucs:outline-none"
                                                                    required
                                                                />
                                                                <span className="dark:text-white text-black text-sm">Someone I Care For</span>
                                                            </label>
                                                    </div>
                                                    <div className="mt-1 flex flex-wrap mb-2 w-full">
                                                            <label key={"Clinic"} className="flex items-center space-x-2 ">
                                                                <input
                                                                    type="radio"
                                                                    name="who"
                                                                    value="Clinic"
                                                                    onChange={handleInputChange}
                                                                    className="h-4 w-4  border-gray-300 focus:ring-[#0CC8E8]"
                                                                    required
                                                                />
                                                                <span className="dark:text-white text-black text-sm">Clinic</span>
                                                            </label>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <button
                                            className="max-w-sm 2xl:max-w-lg xl:max-w-lg lg:max-w-lg md:max-w-md mt-5 hover:bg-[#111920] hover:text-white border-transparent shadow-sm text-sm font-medium text-white bg-gradient-to-r from-[#0CC8E8] to-[#2DEEAA] hover:from-teal-600 hover:to-green-500 py-3 px-5 rounded-md w-full cursor-pointer border border-[#232323]"
                                            type="submit"
                                            onClick={sendEmail}
                                        >
                                            Join Waitlist
                                        </button>
                                    </form>
                                    <p className="form-messege mt-4"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Waitlist;
